module.exports = __webpack_public_path__ + "../resources/img/bg_pv2_01.984e4a43.png";